import VitoloReferral from './VitoloReferral';

export default VitoloReferral;
